import styled from 'styled-components';

export const Header = styled.header`
  height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 72px;
  border: 1px solid #dedede;
  background-color: #fdfdfd;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
`;
